const ROLE_ADMINISTRATOR = 'administrator';
const ROLE_PROVIDER = 'provider';
const ROLE_CLINICAL_STAFF = 'clinical_staff';
const ROLE_NON_CLINICAL_STAFF = 'non_clinical_staff';
const ROLE_FRONT_DESK_STAFF = 'front_desk_staff';
const ROLE_BILLER = 'biller';

export {
  ROLE_ADMINISTRATOR,
  ROLE_CLINICAL_STAFF,
  ROLE_NON_CLINICAL_STAFF,
  ROLE_FRONT_DESK_STAFF,
  ROLE_BILLER,
  ROLE_PROVIDER,
};
